import { parseAsInteger, useQueryState } from 'nuqs'
import { searchParams } from '../utils/generateBreadcrumbItems/search'
import { useCallback, useMemo, useState } from 'react'

export function useTablePagination() {
	const [currentPage, setCurrentPage] = useQueryState(
		'page',
		parseAsInteger.withOptions({ shallow: false }).withDefault(1),
	)
	const [pageSize, setPageSize] = useQueryState(
		'limit',
		parseAsInteger.withOptions({ shallow: false }).withDefault(10),
	)

	const [searchQuery, setSearchQuery] = useQueryState(
		'q',
		searchParams.q.withDefault(''),
	)

	const [selectedQuery, setSelectedQuery] = useQueryState(
		'selectedQuery',
		searchParams.selectedQuery.withDefault(''),
	)

	const [rankFilter, setRankFilter] = useQueryState(
		'rankFilter',
		searchParams.selectedQuery.withDefault(''),
	)

	const [bannedFilter, setBannedFilter] = useQueryState(
		'bannedFilter',
		searchParams.selectedQuery.withDefault(''),
	)

	const [channelFilter, setChannelFilter] = useQueryState(
		'channelFilter',
		searchParams.selectedQuery.withDefault(''),
	)

	const [localSearch, setLocalSearch] = useState('')

	const resetFilters = useCallback(() => {
		setSearchQuery(null)
		setLocalSearch('')
		setRankFilter(null)
		setBannedFilter(null)
		setChannelFilter(null)
		setCurrentPage(1)
	}, [
		setSearchQuery,
		setCurrentPage,
		setBannedFilter,
		setRankFilter,
		setChannelFilter,
	])

	const isAnyFilterActive = useMemo(() => {
		return !!searchQuery || !!rankFilter || !!bannedFilter || !!channelFilter
	}, [searchQuery, rankFilter, bannedFilter, channelFilter])

	return {
		pageSize,
		setPageSize,
		currentPage,
		setCurrentPage,
		searchQuery,
		setSearchQuery,
		resetFilters,
		isAnyFilterActive,
		localSearch,
		setLocalSearch,
		selectedQuery,
		setSelectedQuery,
		rankFilter,
		setRankFilter,
		bannedFilter,
		setBannedFilter,
		channelFilter,
		setChannelFilter,
	}
}
